<template>
  <el-row>
    <div class="tag">
       <!-- <el-radio-group v-model="areaName" size="small" @change="handleChange">
        <el-radio-button value="hlj" label="黑龙江" />
        <el-radio-button value="zh" label="中国" />
      </el-radio-group> -->
      <span @click="handleChangeCity('hlj')" :class="{'active': areaName == 'hlj'}">黑龙江</span>
      <!-- <span :style="{color: '#409eff'}">/</span> -->
      <span @click="handleChangeCity('zh')" :class="{'active': areaName == 'zh'}">中国</span>
    </div>
    <div id="lineEchart" :style="{ width: '100%', height: '200px' }"></div>
  </el-row>
</template>
<script>
import {onMounted, onUnmounted,ref } from 'vue'
import * as echarts from "echarts";
export default {
  name: "trendEchart",
  data(){
    return {
        // areaName: 'hlj',
    }
  },
  setup() {
    // let data1 = ref([1439,1562,1967,2083,2278,2921,3623,4388,4654,4727,4871,5437,6079,6423,7328,7948,8968,8645,7466,3568]);
    // let data2 = ref([151,310,409,428,517,657,765,996,1190,1376,1736,2448,2897,3277,4113,4909,5657,5526,4118,1428]);
    /// 声明定义一下echart
    let areaName = ref('hlj');
    let echart = echarts;
    onMounted(() => {
      lineEchart([29,40,30,61,65,92,114,158,216,225,365,305,282,269,316,354,353,454,425,319,315,45],[0,0,0,1,2,8,2,11,25,41,65,82,73,105,138,153,213,338,275,177,91,0]);
      // lineEchart();
    });

    onUnmounted(() => {
      echart.dispose();
    });
    function handleChangeCity(val) {
      areaName.value = val;
      if(val==='hlj') {
         lineEchart([29,40,30,61,65,92,114,158,216,225,365,305,282,269,316,354,353,454,425,319,315,45],[0,0,0,1,2,8,2,11,25,41,65,82,73,105,138,153,213,338,275,177,91,0]);
      } else {
         lineEchart([1439,1562,1967,2083,2278,2921,3623,4388,4654,4727,4871,5437,6079,6423,7328,7948,8968,11329,10074,9267,6631,793],[151,310,409,428,517,657,765,996,1190,1376,1736,2448,2897,3277,4113,4909,5657,7683,6157,4721,2659,151]);
      }
    }
    function lineEchart(data1,data2) {
      let chart = echart.init(document.getElementById("lineEchart"));
      // 把配置和数据放这里
      chart.setOption({
        xAxis: {
          type: 'category',
          data: [2005, 2006, 2007, 2008, 2009, 2010, 2011, 2012, 2013, 2014, 2015, 2016, 2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024, 2025, 2026],
          axisLabel: {
            show: true, // 是否显示刻度标签，默认显示
            interval: 0, // 坐标轴刻度标签的显示间隔，在类目轴中有效；默认会采用标签不重叠的策略间隔显示标签；可以设置成0强制显示所有标签；如果设置为1，表示『隔一个标签显示一个标签』，如果值为2，表示隔两个标签显示一个标签，以此类推。
            rotate: 60, // 刻度标签旋转的角度，在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠；旋转的角度从-90度到90度
            inside: false, // 刻度标签是否朝内，默认朝外
            margin: 6, // 刻度标签与轴线之间的距离
            color: '#fff',
            fontSize: '14px',
          },
        },
        yAxis: {
          type: 'value',
          axisLabel: {
            color: '#fff',
            fontSize: '14px',
          },
          splitLine: {
            show: false,
          }
        },
          tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['专利申请', '专利授权'],
          right: 50,
          top: 10,
          textStyle: {
            color: '#fff',
            fontSize: 12
          },
        },
        series:  [
        {
          
          name: '专利申请',
          data: data1,
          type: 'line',
          smooth: true,
          itemStyle: {
            normal: {
              color: '#22f2ec',
            }
          }
        },{
          name: '专利授权',
          data: data2,
          type: 'line',
          smooth: true,
          itemStyle: {
            normal: {
              color: '#f6e410',
            }
          }
        }]
      });
      window.onresize = function() {
        //自适应大小
        chart.resize();
      };
    }
    function handleChange(val) {

      if(val==='hlj') {
         lineEchart([29,40,30,61,65,92,114,158,216,225,365,305,282,269,316,354,353,454,432,345,243],[0,0,0,1,2,8,2,11,25,41,65,82,73,105,138,153,213,294,316,203,26]);
        //  lineEchart([29,40,30,61,65,92,114,158,216,225,365,305,282,269,316,354,353,422,342,160],[0,0,0,1,2,8,2,11,25,41,65,82,73,105,138,153,213,282,176,51]);
      } else {
         lineEchart([1439,1562,1967,2083,2278,2921,3623,4388,4654,4727,4871,5437,6079,6423,7328,7948,8968,8875,7976,7739,3564],[151,310,409,428,517,657,765,996,1190,1376,1736,2448,2897,3277,4113,4909,5657,5734,4538,3646,217]);
        //  lineEchart([1439,1562,1967,2083,2278,2921,3623,4388,4654,4727,4871,5437,6079,6423,7328,7948,8968,8645,7466,3568],[151,310,409,428,517,657,765,996,1190,1376,1736,2448,2897,3277,4113,4909,5657,5526,4118,1428]);
      }
    }
    return { lineEchart, handleChange, handleChangeCity, areaName};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.tag{
  margin: 0 auto;
  margin-bottom: 10px;
}
.tag span{
  display: inline-block;
  width: 60px;
  text-align: center;
  padding: 6px;
  cursor: pointer;
  color: #508cff;
  background: #0e2e6c;
 }
 .tag span.active{
  color: #fff;
  background: #0071ff;
  font-weight: 500;
 }
/* .tag /deep/.el-radio-button span{
  background: transparent!important;
} */
</style>
